import React from 'react';
import MuiTypography from '@material-ui/core/Typography';
import MuiGrid from '@material-ui/core/Grid';
import MuiBox from '@material-ui/core/Box';

export default function Header({ labelName, asOfDate }) {
  return (
    <MuiBox pl={1}>
      <MuiGrid container spacing={1}>
        <MuiGrid item xs={10}>
          <MuiTypography variant="caption">Label Name</MuiTypography>
          <MuiTypography variant="h4">{labelName}</MuiTypography>
        </MuiGrid>
        <MuiGrid item xs={2}>
          <MuiTypography variant="caption">As of {asOfDate}</MuiTypography>
        </MuiGrid>
      </MuiGrid>
    </MuiBox>
  );
}
